import script from "./AuraProcessingCostsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraProcessingCostsHeader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__